<script>
    import drawer from './drawer';
    import tuitionTable from './tuitionTable'

    export default {
        name: 'drawers',

        props: {
            groupedPrograms: {},
            isUndergrad: null
        },

        components: { drawer, tuitionTable }

    }
</script>

<template>
    <ul class="m-drawers" role="tablist" data-accordion data-allow-all-closed="true" data-multi-expand="false">
        <drawer v-for="(school, i) in groupedPrograms" :key="i" :title="school.fullName">
            <div v-if="school.hasChildren" >
              <div v-for="(subSchool, j) in school.children" :key="j">
                <div class="m-drawer__subschoolTitle">{{subSchool.fullName}}</div>
                <tuitionTable :degrees="subSchool.degrees" :isUndergrad="isUndergrad"/>
              </div>
            </div>
            <div v-else>
              <tuitionTable :degrees="school.degrees" :isUndergrad="isUndergrad"/>
            </div>
            <div class="tf-notes" v-html="school.notes"></div>
        </drawer>
    </ul>
</template>